import '@tamagui/core/reset.css'

import { Button, Form, Input, Checkbox, TamaguiProvider, XStack, YStack, Label, H4, Spinner, Text, Separator } from 'tamagui'
import { Check } from '@tamagui/lucide-icons'
import { LinearGradient } from 'tamagui/linear-gradient'
import { BrowserRouter, Route, Routes, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Header } from '../../components/Header'
import { CheckboxWithLabel } from '../../components/CheckboxWithLabel'
import { login, LoginData } from '../../remote/login'
import { UserSessionData, useUserSessionStorage } from '../../SessionData'

export const Login = () => {
	const navigate = useNavigate()
	const [userSessionStorage, setUserSessionStorage] = useUserSessionStorage(new UserSessionData());

	const [status, setStatus] = useState<'off' | 'submitting' | 'submitted'>('off')
	useEffect(() => {
		if (status === 'submitting') {
			const timer = setTimeout(() => setStatus('off'), 20000)
			return () => {
				clearTimeout(timer)
			}
		}
	}, [status])

	const [email, setEmail] = useState('')
	const handleEmailInputChange = (event) => {
		setEmail(event.target.value)
	}

	const [phone, setPhone] = useState('')
	const handlePhoneInputChange = (event) => {
		setPhone(event.target.value)
	}

	const [password, setPassword] = useState('')
	const handlePasswordInputChange = (event) => {
		setPassword(event.target.value)
	}

	const submitForm = () => {
		setStatus('submitting')
		login(new LoginData(password, email ? email : undefined, phone ? phone : undefined), (response) => {
			if (response?.status == 200) {
				let newData = new UserSessionData()
				Object.assign(newData, userSessionStorage);
				newData.loggedIn = true;
				setUserSessionStorage(newData);
				setStatus('submitted');
				navigate('/');
			}
		});
	}

	return (
		<>
			<Header />
			<YStack flex={1} items="center" justify="center">
				<Form
					alignItems="center"
					minWidth={600}
					gap="$2"
					onSubmit={submitForm}
					borderWidth={1}
					borderRadius="$4"
					backgroundColor="$background"
					borderColor="$borderColor"
					padding="$8"
				>
					<H4>Welcome back to cytrusted!</H4>
					<XStack alignItems='stretch' gap='$4'>
						<YStack alignItems="center" gap="$1">
							<Label htmlFor='email'>Email address</Label>
							<Input id='email' value={email} onChange={handleEmailInputChange} inputMode='email' size="$4" borderWidth={2} flex={1} />
						</YStack>
						<YStack alignItems='stretch' gap='$1'>
							<Separator alignSelf="center" vertical />
							<Text marginTop='$2' marginBottom='$2'>or</Text>
							<Separator alignSelf="center" vertical />
						</YStack>
						<YStack alignItems="center" gap="$1">
							<Label htmlFor='phone'>Phone number</Label>
							<Input id='phone' value={phone} onChange={handlePhoneInputChange} inputMode='tel' size="$4" borderWidth={2} flex={1} />
						</YStack>
					</XStack>
					<Separator alignSelf="stretch" marginTop='$4' />
					<YStack alignItems="center" gap="$1">
						<Label htmlFor='password'>Password</Label>
						<Input id='password' value={password} onChange={handlePasswordInputChange} secureTextEntry={true} size="$4" borderWidth={2} flex={1} />
					</YStack>
					<Form.Trigger asChild>
						<Button icon={status === 'submitting' ? () => <Spinner /> : status === 'submitted' ? Check : null}>Log in</Button>
					</Form.Trigger>
				</Form>
			</YStack>
		</>
	)
}
